<div mat-dialog-content class="account-info-details p--md color--white">
  <h1 class="mb--none color--white">{{ data && data.firstName }} {{ data && data.lastName }}</h1>
  <div class="my--xxs ">
    <span class="label color--medium-grey">{{ 'App.AccountInfo.UserRole' | translate }}: </span>
    <span class="color--white">{{ data.role }}</span>
  </div>
  <div class="my--xxs">
    <span class="label color--medium-grey">{{ 'App.AccountInfo.EmailID' | translate }}: </span>
    <span class="color--white">{{ data.email }}</span>
  </div>
</div>

<div class="row account-info-actions p--none" mat-dialog-actions>
  <div mat-dialog-close class="logout-button" (click)="logout()">
    <span class="icon-logout mr--xs"></span>
    <span class="color--navy">{{ 'App.LogOut' | translate }}</span>
  </div>
</div>
